import React from 'react';

export interface OptionTile {
  id: string;
  label: string;
  hint?: string;
}

interface SingleSelectGridProps {
  title: string;
  options: OptionTile[];
  selected: string | null;
  onSelect: (id: string) => void;
}

const SingleSelectGrid: React.FC<SingleSelectGridProps> = ({ title, options, selected, onSelect }) => {
  return (
    <div>
      <h2 className="text-2xl font-bold text-secondary leading-snug mb-6">{title}</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {options.map(option => {
          const isSel = selected === option.id;
          return (
            <button
              key={option.id}
              type="button"
              onClick={() => onSelect(option.id)}
              className={[
                'text-left p-4 rounded-xl border-2 transition-all duration-150 flex items-start gap-3 bg-white',
                isSel
                  ? 'border-primary shadow-[0_4px_16px_-8px_rgba(138,48,51,0.4)]'
                  : 'border-gray-200 hover:border-primary/40 hover:shadow-sm',
              ].join(' ')}
            >
              <div className={[
                'mt-0.5 w-5 h-5 rounded-full border-2 grid place-items-center shrink-0 transition-colors',
                isSel ? 'border-primary bg-primary' : 'border-gray-300',
              ].join(' ')}>
                {isSel && (
                  <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-3 h-3">
                    <path d="M5 12.5l4.5 4.5L19 7" />
                  </svg>
                )}
              </div>
              <div className="min-w-0">
                <div className="font-semibold text-sm text-secondary">{option.label}</div>
                {option.hint && <div className="text-xs text-gray-500 mt-0.5">{option.hint}</div>}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SingleSelectGrid;
